import { containsOneOfSpecificErrors } from '../../../../ory/errors/errorParser';
import { IUseLoginApi } from '../../../../ory/hooks/oryApi';
import { IUseOryResponseParser } from '../../../../ory/hooks/oryResponseParser';
import { OryErrorNamedMessageId } from '../../../../ory/types';

export interface ILoginWithSAMLParams {
  organizationId: string;
  loginToOryWithSAML: IUseLoginApi['loginToOryWithSAML'];
  parseOryResponseWithData: IUseOryResponseParser['parseOryResponseWithData'];
  refreshSession: boolean | undefined;
}

export async function samlLogin({
  loginToOryWithSAML,
  organizationId,
  parseOryResponseWithData,
  refreshSession,
}: ILoginWithSAMLParams) {
  const response = await loginToOryWithSAML({ organizationId, refreshSession });
  parseOryResponseWithData({
    onError(error) {
      if (
        error &&
        containsOneOfSpecificErrors(error, [OryErrorNamedMessageId.Session_already_available]) &&
        !refreshSession
      ) {
        samlLogin({
          loginToOryWithSAML,
          organizationId,
          parseOryResponseWithData,
          refreshSession: true,
        });
      }
    },
    onSuccess(data) {
      window.location.href = data.redirect_browser_to;
    },
    response,
  });
}
